<template>
  <v-app id="app" ref="container">
    <AddClubs ref="container"></AddClubs>
  </v-app>
</template>

<script>
import { configCollection } from "@/firebase";
import AddClubs from "./AddClubs.vue";

export default {
  name: "App",
  components: {
    AddClubs,
  },

  data: () => ({
    timer: null,
  }),
  created() {
    configCollection
      .doc("default")
      .get()
      .then((res) => {
        this.$store.commit("set_config", res.data());
      })
      .catch((err) => {
        console.log(err);
      });
  },

  mounted() {
    this.timer = setInterval(this.iframeHeightNotify, 300);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    iframeHeightNotify() {
      var msg = {
        height: this.$refs.container.$el.scrollHeight,
      };
      window.parent.postMessage(msg, "*");
    },
  },
};
</script>

<style>
.nav {
  display: flex;
  gap: 1rem;
  margin: 1rem;
  align-items: center;
}
</style>
